<ds-modal [modal]="modal" [title]="'generate_amp_api_key_label' | translate" [maxWidthPercentage]="50">
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <p class="amp-api-key-description">{{ 'amp_api_key_modal_description' | translate }}</p>
        </div>
      </div>
      <div class="row my-3 p-2 amp-api-key-details">
        <div class="col-12">
          <div class="my-2 amp-api-key-details-label">{{ 'api_token_generated_name_label' | translate }}</div>
          <div class="mb-2 amp-api-key-details-name">{{ keyName }}</div>
          <div class="mb-2 amp-api-key-details-label">{{ 'api_token_generated_key_label' | translate }}</div>
          @if (displayWarning) {
            <div class="d-flex center mb-2 amp-api-key-details-warning" role="alert">
              <div class="me-2">
                <ds-icon [icon]="Icons.TriangleExclamation" [iconStyle]="IconStyles.Regular"></ds-icon>
              </div>
              <div class="me-3">
                <p>{{ 'amp_api_key_modal_warning' | translate: expiry }}</p>
              </div>
              <div>
                <button
                  ds-button
                  [variant]="DsButtonVariants.microAction"
                  [microActionIcon]="Icons.XMark"
                  (click)="closeWarning()"
                ></button>
              </div>
            </div>
          }
          <div class="mb-2 amp-api-key-details-key">
            <div class="col-12">
              <p>{{ key }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-auto">
      <a
        class="btn btn-primary btn-lg"
        data-test-id="amp-api-key-button-download"
        [href]="downloadUrl | safeContent: SecurityContext.RESOURCE_URL"
        [download]="downloadFileName"
        >{{ 'action_download' | translate }}</a
      >
    </div>
    <div class="col-auto">
      <button ds-button [variant]="DsButtonVariants.secondary" (click)="closeModal()" data-test-id="amp-api-key-button-close">
        {{ 'close' | translate }}
      </button>
    </div>
  </div>
</ds-modal>
